export const ITEMS = [
    "none",
    "webHook",
    "CRM",
    "inAgentConsole",
    "openNewBrowserTab",
  ];